const firebaseConfig = {
  apiKey: 'AIzaSyCmuu_sYgDo3640UP9alHFTRQYswqhy5WQ',
  authDomain: 'owqlo-master-production-id.firebaseapp.com',
  databaseURL: 'https://owqlo-master-production-id.firebaseio.com',
  projectId: 'owqlo-master-production-id',
  storageBucket: 'owqlo-master-production-id.appspot.com',
  messagingSenderId: '737501983455',
  appId: '1:737501983455:web:ebb228383c8ee66e'
}

const stripeConfig = {
  publishableKey: 'pk_live_LK4YX1EGRiKAgJDJ9NdqbWuI00e5Ja8SmN',
  fileUploadEndpoint: `https://${process.env.VUE_APP_FUNCTIONS_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/rest/uploadFileToStripe`,
}

const sentryConfig = {
  dsn: 'https://eaf8d474568c40c680f5bb644ebef629@sentry.io/1529153',
}

const backendUrl = `https://${process.env.VUE_APP_FUNCTIONS_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/graphql`
const owqloWebsiteUrl = 'https://owqlo.com'

export default {
  firebaseConfig,
  stripeConfig,
  sentryConfig,
  backendUrl,
  owqloWebsiteUrl,
}
